<div class="master-card shadow-sm p-4 rounded bg-white">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
            <h3 class="m-0 fw-bold text-dark">Master Roles</h3>
            <p class="text-muted small m-0">View all roles for a specific client</p>
        </div>
        <div class="d-flex gap-2 align-items-center">
            <div class="btn-group btn-group-sm">
                <button 
                    *ngFor="let type of projectTypes" 
                    type="button" 
                    class="btn" 
                    [class.btn-primary]="selectedClient === type.value"
                    [class.btn-outline-secondary]="selectedClient !== type.value"
                    (click)="switchClient(type.value)">
                    {{ type.label }}
                </button>
            </div>
            <button class="btn btn-outline-secondary btn-sm rounded-0" (click)="loadRoles()">
                <i class="pi pi-refresh"></i>
            </button>
        </div>
    </div>

    <p-table 
        [value]="roles" 
        [loading]="loading" 
        [rows]="10" 
        [paginator]="true" 
        responsiveLayout="scroll"
        styleClass="p-datatable-sm p-datatable-striped">
        <ng-template pTemplate="header">
            <tr>
                <th>Role Name</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-role>
            <tr>
                <td class="fw-medium text-primary">{{ role.roleName }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="1" class="text-center py-4 text-muted">No roles found for {{ selectedClient }}.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
<p-toast></p-toast>
